module.exports = __webpack_public_path__ + "static/media/country-3.8551d9d6.jpg";